import { computed, onScopeDispose, shallowRef, toValue, watch } from "vue";
import { createMapScene } from "#ce/apps/SpFinderMap/lib/map-scene";
import { createMapClusters } from "#ce/apps/SpFinderMap/lib/map-clusters";

/** Reconciles injected map/records/selection inputs and releases the scene with its Vue scope. */
export function useFinderMapScene({
  map,
  maps,
  records,
  selected,
  icons,
  renderInfo,
  onClose,
  Clusterer,
  clusterMarkers = false,
}) {
  const scene = shallowRef();

  function disconnect() {
    scene.value?.dispose();
    scene.value = undefined;
  }

  function connect() {
    disconnect();
    if (!toValue(map) || !toValue(maps)) {
      return;
    }
    scene.value = createMapScene({
      map: toValue(map),
      maps: toValue(maps),
      icons: toValue(icons),
      renderInfo,
      onClose,
    });
    replaceRecords();
  }

  function selectRecord() {
    scene.value?.select(toValue(selected));
  }

  function replaceRecords() {
    if (!scene.value) {
      return;
    }
    scene.value.replace(toValue(records) ?? []);
    if (toValue(clusterMarkers) && Clusterer && scene.value.markers().length) {
      scene.value.setClusters(
        createMapClusters({
          map: toValue(map),
          maps: toValue(maps),
          markers: scene.value.markers(),
          Clusterer,
          selectedIcon: toValue(icons).clusterSelected,
          open: scene.value.openCluster,
        }),
      );
    }
    selectRecord();
  }

  watch([() => toValue(map), () => toValue(maps), () => toValue(icons)], connect, { immediate: true });
  watch([() => toValue(records), () => toValue(clusterMarkers)], replaceRecords);
  watch(() => toValue(selected), selectRecord);
  onScopeDispose(disconnect);
  return { scene: computed(() => scene.value) };
}
